<script>
export default {
  name: 'NoDataMessage',
  props: {
    noDataTitle: {
      type: String,
      default: 'Sem dados no momento.',
    },
    noDataDescription: {
      type: String,
      default:
        'Os dados podem não terem sido cadastrados ou não estão no recorte dos filtros selecionados.',
    },
    align: {
      type: String,
      default: 'center',
      validator: (value) => ['center', 'left', 'right'].includes(value),
    },
  },
}
</script>

<template>
  <div class="no-data-message" :class="`no-data-message--${align}`">
    <div class="no-data-message__content">
      <div class="no-data-message__title">
        {{ noDataTitle }}
      </div>
      <div class="no-data-message__description">
        {{ noDataDescription }}
      </div>
    </div>
  </div>
</template>

<style lang="sass">
.no-data-message
  display: flex
  justify-content: center
  align-items: center
  width: 100%
  height: 100%
  min-height: 200px
  color: #5e5e5e
  text-align: center
  padding: 24px
  box-sizing: border-box

  &__content
    max-width: 80%

  &--left
    text-align: left
    align-items: flex-start

  &--right
    text-align: right
    align-items: flex-end

  &__title
    font-size: 1rem
    font-weight: 500
    margin-bottom: 8px
    line-height: 1.4

  &__description
    font-size: 0.875rem
    opacity: 0.8
    line-height: 1.4
</style>
